<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spJuzgado" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="Nombre" maxlength="100" />
            <mat-error *ngIf="f.Nombre.errors?.required">Campo obligatorio</mat-error>
            <mat-error *ngIf="f.Nombre.errors?.maxlength">Máximo 100 caracteres</mat-error>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput formControlName="Descripcion" maxlength="100" />
            <mat-error *ngIf="f.Descripcion.errors?.maxlength">Máximo 100 caracteres</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Domicilio</mat-label>
            <input matInput formControlName="Domicilio" maxlength="200" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Teléfono</mat-label>
            <input matInput formControlName="Telefono" maxlength="50" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Correo electrónico</mat-label>
            <input matInput formControlName="Correo" maxlength="100" />
            <mat-error *ngIf="f.Correo.errors?.email">Formato inválido</mat-error>
            <mat-error *ngIf="f.Correo.errors?.maxlength">Máximo 100 caracteres</mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Región</mat-label>
            <input matInput formControlName="Region" maxlength="100" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">

        <app-selector-localidad-provincia [idLocalidadSeleccionadaInput]="juzgado.idLocalidad"
          (localidadSeleccionada)="onLocalidadSeleccionada($event)">
        </app-selector-localidad-provincia>

      </div>
      <div class="row">

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spJurisdicciones" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Jurisdiccion</mat-label>
            <input type="text" placeholder="Seleccione opcion" matInput formControlName="IdJurisdiccion"
              [matAutocomplete]="autoJuri" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-error *ngIf="f.IdJurisdiccion.errors?.required">Este campo es
              <strong>requerido</strong>.</mat-error>
            <mat-autocomplete #autoJuri="matAutocomplete" [displayWith]="displayJurisdiccionFn">
              <mat-option *ngFor="let jurisdiccion of filteredJurisdiccionOptions | async" [value]="jurisdiccion">
                {{ jurisdiccion.descripcion}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spFueros" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Fuero</mat-label>
            <input type="text" placeholder="Seleccione opcion" matInput formControlName="IdFuero"
              [matAutocomplete]="autoFuero" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-error *ngIf="f.IdFuero.errors?.required">Este campo es
              <strong>requerido</strong>.</mat-error>
            <mat-autocomplete #autoFuero="matAutocomplete" [displayWith]="displayFueroFn">
              <mat-option (onSelectionChange)="selectFuero(fuero)" *ngFor="let fuero of filteredFuerosOptions | async"
                [value]="fuero">
                {{ fuero.descripcion}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col"
          *ngFor="let campo of ['Nominacion', 'Subnominacion', 'Competencia', 'Grado', 'Numero', 'Letra']">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ campo }}</mat-label>
            <input matInput [formControlName]="campo" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Horario de atención</mat-label>
            <input matInput formControlName="HorarioAtencion" maxlength="100" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>URL Sistema de Gestión</mat-label>
            <input matInput formControlName="UrlSistemaGestion" maxlength="200" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="row">
          <div class="col-auto">
            <mat-checkbox formControlName="EsActivo">
              ¿Esta activo?
            </mat-checkbox>
          </div>
          <div class="col-auto">
            <mat-checkbox formControlName="EsSecretaria">
              ¿Es una secreataria?
            </mat-checkbox>
          </div>
          <div class="col-auto">
            <mat-checkbox formControlName="TieneMesaVirtual">
              ¿Tiene mesa virtual¡
            </mat-checkbox>
          </div>
        </div>
      </div>
      <br>


      <div class="row">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Observaciones</mat-label>
          <textarea matInput formControlName="Observaciones" maxlength="500"></textarea>
          <mat-hint align="end">{{ form.get('Observaciones')?.value?.length || 0 }} / 500</mat-hint>
        </mat-form-field>
      </div>
    </ng-template>
  </form>


</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">
    <div class="row">
      <div class="col">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Generales</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Nombre:</span> <span class="property-value">{{
                data.juzgado.nombre }}</span></div>
            <div class="property-row"><span class="property-name">Descripción:</span> <span class="property-value">{{
                data.juzgado.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Observaciones:</span> <span class="property-value">{{
                data.juzgado.observaciones }}</span></div>
            <div class="property-row"><span class="property-name">Domicilio:</span> <span class="property-value">{{
                data.juzgado.domicilio }}</span></div>
            <div class="property-row"><span class="property-name">Teléfono:</span> <span class="property-value">{{
                data.juzgado.telefono }}</span></div>
            <div class="property-row"><span class="property-name">Correo:</span> <span class="property-value">{{
                data.correo }}</span></div>
            <div class="property-row"><span class="property-name">Región:</span> <span class="property-value">{{
                data.juzgado.region }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">

        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Ubicación</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Localidad:</span> <span class="property-value">{{
                data.juzgado.localidad?.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">País:</span> <span class="property-value">{{
                data.juzgado.pais?.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Jurisdicción:</span> <span class="property-value">{{
                data.juzgado.jurisdiccion?.descripcion }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Detalles judiciales</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <div class="property-row"><span class="property-name">Fuero:</span> <span class="property-value">{{
                data.juzgado.fuero?.descripcion }}</span></div>
            <div class="property-row"><span class="property-name">Nominación:</span> <span class="property-value">{{
                data.juzgado.nominacion }}</span></div>
            <div class="property-row"><span class="property-name">Subnominación:</span> <span class="property-value">{{
                data.juzgado.subnominacion }}</span></div>
            <div class="property-row"><span class="property-name">Competencia:</span> <span class="property-value">{{
                data.juzgado.competencia }}</span></div>
            <div class="property-row"><span class="property-name">Grado:</span> <span class="property-value">{{
                data.juzgado.grado }}</span></div>
            <div class="property-row"><span class="property-name">Número:</span> <span class="property-value">{{
                data.juzgado.numero }}</span></div>
            <div class="property-row"><span class="property-name">Letra:</span> <span class="property-value">{{
                data.juzgado.letra }}</span></div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">

        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Estado y configuración</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row">
              <span class="property-name">Activo:</span>
              <span class="property-value">
                <mat-icon matTooltip="¿Está activo?">{{ data.juzgado.esActivo ? 'toggle_on' : 'toggle_off' }}</mat-icon>
                {{ data.juzgado.esActivo ? 'Sí' : 'No' }}
              </span>
            </div>
            <div class="property-row">
              <span class="property-name">Es Secretaría:</span>
              <span class="property-value">
                <mat-icon matTooltip="¿Es una secretaría?">apartment</mat-icon>
                {{ data.juzgado.esSecretaria ? 'Sí' : 'No' }}
              </span>
            </div>
            <div class="property-row">
              <span class="property-name">Mesa Virtual:</span>
              <span class="property-value">
                <mat-icon matTooltip="¿Tiene mesa virtual?">support_agent</mat-icon>
                {{ data.juzgado.tieneMesaVirtual ? 'Sí' : 'No' }}
              </span>
            </div>
            <div class="property-row" *ngIf="data.juzgado.horarioAtencion">
              <span class="property-name">Horario Atención:</span>
              <span class="property-value">
                <mat-icon matTooltip="Horario de atención">schedule</mat-icon>
                {{ data.juzgado.horarioAtencion }}
              </span>
            </div>
            <div class="property-row" *ngIf="data.juzgado.urlSistemaGestion">
              <span class="property-name">Sistema Gestión:</span>
              <span class="property-value">
                <mat-icon matTooltip="Sistema de gestión">computer</mat-icon>
                {{ data.juzgado.urlSistemaGestion }}
              </span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
